import { Outlet } from 'react-router-dom';
import { useAppSetup } from '../../../hooks/setup/useAppSetup';

export const AppSetup = () => {
  useAppSetup();

  return <Outlet />;
};
